import React, { PureComponent } from 'react';
import {
  Image,
  Grid,
  Form,
  Input,
  Dropdown,
  Button,
  Divider,
  Popup,
  Icon,
  Label,
  Checkbox
} from 'semantic-ui-react';
import constants from '../constants/constants';
import Images from '../../../assets/Images';
import { fetchThumbnail } from '../../../utils/thumbnailRecovery';
import './AdLibraryLaunch.css';

const { LAUNCHER } = constants;
const {
  CAROUSEL,
  STILL,
  VIDEO,
  CINEMAGRAPH,
  DAA,
  CANVAS,
  COLLECTION
} = LAUNCHER;

class AdLibraryLaunchFieldsComponent extends PureComponent {
  state = {
    openTooManyVideosWarning: false
  };

  async componentWillMount() {
    const { adPrototype } = this.props;
    await this.getProperCarouselCardThumbnail(adPrototype);
  }

  async componentDidUpdate(prevProps) {
    const { adPrototype: prevAdPrototype } = prevProps;
    const { adPrototype } = this.props;
    if (prevAdPrototype.id !== adPrototype.id) {
      await this.getProperCarouselCardThumbnail(adPrototype);
    }
  }

  getProperCarouselCardThumbnail = async (adPrototype) => {
    const { getFbToken, setStateInGrandparent, thumbnails } = this.props;
    const token = getFbToken ? getFbToken() : '';
    const { cards, type } = adPrototype;
    const isCarousel = type === CAROUSEL;
    if (thumbnails.length <= 0) {
      if (cards && cards.length > 0 && isCarousel) {
        try {
          const recoveredThumbnailObjects = await this.returnRecoveredThumbnailObjects(
            cards,
            token
          );
          if (setStateInGrandparent) {
            setStateInGrandparent({ thumbnails: recoveredThumbnailObjects });
          }
        } catch (error) {
          // console.log('getProperCarouselCardThumbnail:', error);
        }
      }
    }
  };

  returnRecoveredThumbnailObjects = async (cards, token) => {
    const recoveredThumbnailObjects = await Promise.all(
      cards.map(async (card) => {
        const { id } = card;
        const recoveredThumbnail = await fetchThumbnail(card, token, 'card');
        const newThumbnailObj = {
          id,
          thumbnail:
            recoveredThumbnail && recoveredThumbnail.trim() !== ''
              ? recoveredThumbnail
              : Images.missingThumbnail
        };
        return Promise.resolve(newThumbnailObj);
      })
    );
    return Promise.resolve(recoveredThumbnailObjects);
  };

  getMatchingThumbnail = (id) => {
    const { thumbnails } = this.props;
    const foundThumbnailObj = thumbnails.find((thumbnailObj) => {
      return thumbnailObj.id === id;
    });
    const thumbnail = foundThumbnailObj
      ? foundThumbnailObj.thumbnail
      : Images.missingThumbnail;
    return thumbnail;
  };

  toggleTooManyVideoWarning = () => {
    const { openTooManyVideosWarning } = this.state;
    this.setState((prevState) => ({
      ...prevState,
      openTooManyVideosWarning: !openTooManyVideosWarning
    }));
  };

  tooManyVideosWarningPopupStyle = (numberOfVideoCards) => {
    const style =
      numberOfVideoCards >= 5
        ? { color: 'red', opacity: 0.75 }
        : { color: 'black', opacity: 0.85 };
    return style;
  };

  countVideoCards = (adPrototype) => {
    const { cards } = adPrototype;
    let videoCounter = 0;
    if (cards) {
      cards.forEach((card) => {
        const { video } = card;
        if (video && video.trim() !== '') {
          videoCounter = videoCounter + 1;
        }
      });
    }
    return videoCounter;
  };

  handleAdCardChange = (event, { value, cardId }) => {
    const { handleAdCardChange } = this.props;
    if (handleAdCardChange) {
      handleAdCardChange(null, { value, cardId });
      this.forceUpdate();
    }
  };

  render() {
    const { openTooManyVideosWarning } = this.state;
    const {
      adPrototype,
      relaunchAd,
      handleAdChange,
      onProductCatalogSelection,
      productCatalog,
      productCatalogs,
      onProductSetSelection,
      onDescriptionSelection,
      productSet,
      productSets,
      description,
      destinationUrl,
      footerUrl,
      formCards,
      needToRelaunchAd,
      processing
    } = this.props;

    const descriptionOptions = [
      {
        key: 0,
        text: 'At dealership',
        value: 'At {{vehicle.dealer_name}}'
      },
      {
        key: 1,
        text: 'Vehicle price',
        value: '{{vehicle.price}}'
      },

      {
        key: 2,
        text: 'VIN number',
        value: '{{vehicle.vehicle_id}}'
      },
      {
        key: 3,
        text: 'Click to View Price',
        value: 'Click to View Price'
      }
    ];

    const numberOfVideoCards = this.countVideoCards(adPrototype);
    const isCarousel = adPrototype.type === CAROUSEL;
    const lowerCaseDestinationUrl = (destinationUrl || '').toLowerCase();
    const isDestinationValid =
      lowerCaseDestinationUrl.includes('http://') ||
      lowerCaseDestinationUrl.includes('https://');
    return (
      <div className={isCarousel ? '' : 'ad-library-launch-item-fields'}>
        <div className={isCarousel ? '' : 'ad-library-launch-container'}>
          <div style={isCarousel ? {} : { width: '100%' }}>
            {isCarousel && formCards.length > 0
              ? formCards.map((card) => {
                  const { cardId, destinationUrl: cardDestinationUrl } = card;
                  const lowerCaseValue = (
                    cardDestinationUrl || ''
                  ).toLowerCase();
                  const isCardUrlValid =
                    lowerCaseValue.includes('http://') ||
                    lowerCaseValue.includes('https://');
                  return (
                    <div>
                      <Grid stackable doubling verticalAlign="middle">
                        <Grid.Row>
                          <Grid.Column width={2} style={{ padding: 0 }}>
                            <Image
                              className="carousel-card-image"
                              src={this.getMatchingThumbnail(cardId)}
                            />
                          </Grid.Column>
                          <Grid.Column width={14}>
                            {cardDestinationUrl ? (
                              <Input
                                style={{ width: '100%' }}
                                placeholder="Destination URL"
                                type="text"
                                name="destinationUrl"
                                cardId={cardId}
                                value={cardDestinationUrl}
                                onChange={this.handleAdCardChange}
                              />
                            ) : (
                              <Input
                                style={{ width: '100%' }}
                                placeholder="Destination URL"
                                type="text"
                                name="destinationUrl"
                                cardId={cardId}
                                onChange={this.handleAdCardChange}
                              />
                            )}
                            {!isCardUrlValid ? (
                              <Label
                                pointing
                                basic
                                color={
                                  cardDestinationUrl &&
                                  cardDestinationUrl.trim() !== ''
                                    ? 'red'
                                    : undefined
                                }
                                content={
                                  'A valid URL must contain http:// or https://'
                                }
                              />
                            ) : null}
                          </Grid.Column>
                        </Grid.Row>
                      </Grid>
                      <Divider hidden />
                    </div>
                  );
                })
              : null}

            {[STILL, VIDEO, CINEMAGRAPH, DAA, CANVAS].includes(
              adPrototype.type
            ) ? (
              <div>
                <Form.Input
                  style={{ width: '100%' }}
                  placeholder="Destination URL"
                  type="text"
                  name="destinationUrl"
                  value={destinationUrl}
                  onChange={handleAdChange}
                />
                {!isDestinationValid ? (
                  <Label
                    pointing
                    basic
                    color={
                      destinationUrl && destinationUrl.trim() !== ''
                        ? 'red'
                        : undefined
                    }
                    content={'A valid URL must contain http:// or https://'}
                  />
                ) : null}
              </div>
            ) : null}
            {adPrototype.type === COLLECTION ? (
              <div>
                <Form.Input
                  style={{ width: '100%' }}
                  placeholder="Footer Url"
                  type="text"
                  name="footerUrl"
                  value={footerUrl}
                  onChange={handleAdChange}
                />
                <Divider hidden />
                <Dropdown
                  placeholder="Product Catalog"
                  style={{ width: '100%' }}
                  search
                  selection
                  name="productCatalog"
                  options={productCatalogs}
                  value={productCatalog}
                  onChange={onProductCatalogSelection}
                />
                <Divider hidden />
                <Dropdown
                  placeholder="Product set"
                  disabled={!productSets || productSets.length <= 0}
                  style={{ width: '100%' }}
                  search
                  selection
                  name="productSet"
                  options={productSets}
                  value={productSet}
                  onChange={onProductSetSelection}
                />
                <Divider hidden />
                <div>
                  <span>
                    <b>Product Description:</b>
                  </span>
                </div>
                <br />
                <Dropdown
                  style={{ width: '100%' }}
                  placeholder="At dealership"
                  search
                  name="description"
                  selection
                  options={descriptionOptions}
                  value={description}
                  onChange={onDescriptionSelection}
                />
              </div>
            ) : null}
          </div>
        </div>
        <Divider hidden />
        {needToRelaunchAd ? (
          <Grid stackable>
            <Grid.Row columns={2}>
              <Grid.Column width={12} verticalAlign="middle">
                {adPrototype.type === COLLECTION && (
                  <Checkbox
                    disabled={processing}
                    label="Convert to Cinempagraph"
                    onChange={() =>
                      this.props.alterIdsOfCollectionAdsToConvert(
                        adPrototype.id
                      )
                    }
                    checked={this.props.idsOfCollectionAdsToConvert.includes(
                      adPrototype.id
                    )}
                  />
                )}
              </Grid.Column>
              <Grid.Column width={4}>
                <Button
                  onClick={relaunchAd}
                  disabled={processing}
                  size="medium"
                  color="yellow"
                  floated="right"
                  icon
                  labelPosition="left"
                >
                  <Icon name="refresh" />
                  Relaunch
                </Button>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        ) : null}
        {adPrototype.type === CAROUSEL ? (
          <Popup
            style={this.tooManyVideosWarningPopupStyle(numberOfVideoCards)}
            position="right center"
            content={`Because of the current limitations of the FB API, it is recommended that there be only 
                            5 videos MAXIMUM in a carousel ad. Otherwise, the ad will likely not launch, either by
                            itself or in a package.`}
            trigger={
              <Button
                floated="right"
                color={numberOfVideoCards >= 5 ? 'red' : undefined}
                icon="info circle"
                onClick={this.toggleTooManyVideoWarning}
              />
            }
            open={openTooManyVideosWarning}
          />
        ) : null}
        <Divider hidden />
      </div>
    );
  }
}

export default AdLibraryLaunchFieldsComponent;



// WEBPACK FOOTER //
// ./src/screens/PackageBuilder/AdLibrary/AdLibraryLaunchFieldsComponent.js